// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kvgQ2","comment":"styles_comment__1eAe9"};